<template>
    <ul class="role_list" v-if="roleList.length > 0 && show">
        <li :class="{ 'role_info': true, 'active': actionData.fictitiousId == item.id }" v-for="(item, i) in roleList"
            :key="i" @click="chooseRole(item.id,item.solution_name,item.server_name, item.role_name)">
            <div class="info">
                <div class="info_name">
                    {{ item.role_name }}
                </div>
                <div class="info_qf">
                    {{ item.app_name }}
                    {{ item.solution_name }}
                    {{ item.server_name }}
                </div>
            </div>
        </li>
    </ul>
    <div v-else class="no_role">暂无角色哦~</div>
</template>

<script>
    export default {
        data() {
            return {
                show: false,
                juheAppId: this.selection.juheAppId,
                roleList: [],
                actionData: {
                    fictitiousId: this.selection.fictitiousId,
                    solution_name: '',
                    server_name: '',
                    role_name: ''
                }
            }
        },
        mounted() {
            this.getroleList()
        },
        methods: {
            //获取角色列表
            getroleList() {
                this.roleList = []
                this.$Ajax("/shop/get-user-role-list", {
                    page: 1,
                    limit: 100,
                    juheAppId: this.juheAppId
                }).then(
                    rs => {
                        if (rs.code == 200) {
                            this.show = true
                            this.roleList = rs.data.list;
                            if (rs.data.page_info.totalPage >= 2) {
                                for (var i = 2; i <= rs.data.page_info.totalPage; i++) {
                                    this.$Ajax("/shop/get-user-role-list", {
                                        page: i,
                                        limit: 100,
                                        juheAppId: this.juheAppId,
                                    }).then(res => {
                                        if (res.code == 200) {
                                            for (var j = 0; j < res.data.list.length; j++) {
                                                this.roleList.push(res.data.list[j]);
                                            }
                                        }
                                    });
                                }
                            }
                        }
                    }
                );
            },
            //选择角色
            chooseRole(id, solution_name, server_name, role_name) {
                this.actionData.fictitiousId = id
                this.actionData.solution_name = solution_name
                this.actionData.server_name = server_name
                this.actionData.role_name = role_name
            },
            _confirm() {
                var that = this
                this.$emit('success', that.actionData)
            }
        },
    }
</script>

<style lang="less" scoped>
    .no_role {
        text-align: center;
        font-size: .6rem;
        color: #9e9e9e;
    }

    .role_list {
        max-height: 260px;
        overflow-y: auto;

        .role_info {
            padding: .6rem .25rem;
            border-bottom: 1px solid #eee;
            border-radius: 4px;
            display: flex;
            align-items: center;
            cursor: pointer;
            &:nth-last-child(1) {
                border: none;
            }
            .info {
                flex: 1;

                .info_name {
                    font-size: 15px;
                    font-weight: 700;

                    span {
                        font-weight: 500;
                        font-size: 13px;
                    }
                }

                .info_qf {
                    font-size: 12px;
                    color: #666;
                }
            }

            &.active {
                background-color: #ECD7D5;

                &:hover {
                    opacity: 0.95;
                }

                .info {
                    .info_name {
                        color: #670000;
                    }
                    .info_qf {
                        color: #666;
                    }
                }
            }

            &.check {
                background-color: #e4e4e4;
            }
        }
    }
</style>